import { useEffect, useState } from "react";
import { LinkCardGrid } from "../../elements/LinkCardGrid";
import { LinkIcon } from "../../icons";
import {
  getWarehouseApplicationCardDescription,
  normalizeWarehouseApplications,
} from "./warehouseApplications";
import { getWarehouseApplications } from "./warehouseApplicationsService";
import { Loading } from "../../elements/Loading";

type WarehouseApplication = ReturnType<typeof normalizeWarehouseApplications>[number];

/** A card for each Warehouse application, opening it to edit. */
export function WarehouseApplicationLinks() {
  const [applications, setApplications] = useState<WarehouseApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    getWarehouseApplications()
      .then((loaded: unknown) => {
        if (!cancelled) {
          setApplications(normalizeWarehouseApplications(loaded));
        }
      })
      .catch((loadError: Error) => {
        if (!cancelled) {
          setError(loadError.message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div className="alert alert-danger mb-0">{error}</div>;
  }

  if (applications.length === 0) {
    return (
      <div className="page-section">
        <h2 className="page-section__title fw-semibold h5 mb-1">
          No Warehouse Applications
        </h2>
        <p className="page-section__helper fs-7 mb-0">
          Create an application to allow a connected system to use the Warehouse API.
        </p>
      </div>
    );
  }

  return (
    <LinkCardGrid
      items={applications.map((application) => ({
        key: String(application.ApplicationId || application.ClientId),
        title: application.ClientId,
        description: getWarehouseApplicationCardDescription(application),
        icon: LinkIcon,
        href: `/warehouse-application?id=${encodeURIComponent(
          String(application.ApplicationId ?? "")
        )}`,
      }))}
    />
  );
}

export default WarehouseApplicationLinks;
